import { useEffect, useState } from "react";
import { useFormik } from "formik";
import useValidations from "../../../utils/hooks/useValidations";
import { login } from "../api";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../store/slices/Global";
import { toast } from "react-toastify";

const useLogin = (emailRef) => {
  const [showPassword, setShowPassword] = useState(true);
  const [loginStatus, setLoginStatus] = useState("idle");
  const [loginInfo, setLoginInfo] = useState({});
  const [forgotPasswordStatus, setForgotPasswordStatus] = useState("idle");

  const { validateEmail } = useValidations();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (loginStatus === "success") {
      dispatch(
        updateConfig((state) => {
          state.isLogged = true;
        })
      );
      navigate("/dashboard");
      // window.location.reload();
    } else if (loginStatus === "failed") {
      let errorFields = Object.keys(loginInfo);
      errorFields.forEach((field) => {
        formik.setFieldError(field, loginInfo[field]);
      });
    }
    // eslint-disable-next-line
  }, [loginStatus]);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: (values) => {
      let errors = {};
      if (!values.email) {
        errors.email = "*Email Required";
      }
      if (!values.password) {
        errors.password = "*Password Required";
      }
      if (!validateEmail(values.email)) {
        errors.email = "*Enter a valid email";
      }
      return errors;
    },
    onSubmit: (values) => {
      emailRef.current = values?.email;
      setLoginStatus("pending");
      login(values).then((response) => {
        if (response?.data?.status_code === 200) {
          localStorage.setItem(
            `USER_ACCESS_TOKEN_CARIBOU`,
            response?.data?.data?.token
          );
          setLoginStatus("success");
          // toast.error("Something went wrong");
        } else if (response?.status_code === 400) {
          toast.error(response?.message);
          setLoginStatus("idle");
        } else if (response?.status_code === 403) {
          setLoginStatus("failed");
          setLoginInfo({ password: response?.message });
        } else if (response?.status_code === 404) {
          toast.error(response?.message);
          setLoginStatus("idle");
        } else if (response?.status_code === 422) {
          setLoginStatus("failed");
          setLoginInfo({ password: response?.message });
        } else {
          setLoginStatus("An error occurred");
        }
      });
    },
  });

  const handleShowPassword = (e) => {
    e.preventDefault();

    setShowPassword(!showPassword);
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  };

  const handleForgotPassword = () => {
    navigate(`/login/forgot-password`);
  };

  return {
    formik,
    loginStatus,
    showPassword,
    forgotPasswordStatus,
    setForgotPasswordStatus,
    handleForgotPassword,
    handleShowPassword,
  };
};

export default useLogin;
